export default {
  title: "Nhập khẩu yêu cầu thanh toán",
  searchPlaceHolder: "Tìm kiếm",
  finish: "Nhập khẩu xong file {0}",
  breadcrumb: {
    step1: "Chọn tệp",
    step2: "Kiểm tra dữ liệu",
    step3: "Kết quả nhập khẩu",
  },
  breadcrumbCopy: {
    step1: "Tải lên tệp nhập khẩu",
    step2: "Ghép trường thông tin",
    step3: "Kiểm tra dữ liệu",
    step4: "Kết quả nhập khẩu",
  },
  upload: {
    label: "Kéo và thả tệp vào đây",
    or: "hoặc",
    button: "Chọn tệp",
    button2: "Tải tệp khác",
    des: "Chấp nhận tệp .xls, .xlsx và .ods có dung lượng tối đa 20MB.",
    error: {
      Invalid: "Tệp nhập khẩu không đúng định dạng",
      SizeInvalid: "Dung lượng vượt quá 20MB, vui lòng chọn lại tệp khác.",
    },
    des02: "Chấp nhận file .doc, .docx, .rtf, .txt và .odt",
  },
  warning: {
    label: "Lưu ý",
    l1: "Để có kết quả nhập khẩu chính xác, hãy sử dụng tệp mẫu.",
    l2: "Mỗi dòng dữ liệu trong tệp nhập khẩu tương ứng với 1 bản ghi",
    notPickTitleRow: "Chưa chọn số dòng tiêu đề.",
    notPickSheetRow: "Chưa chọn sheet nhập khẩu.",
    download: "Tải tệp mẫu",
    closePopup: "Bạn có muốn hủy bỏ việc nhập khẩu không?",
    notPickMappingRow: "Cột: <{0}> không được để trống",
  },
  file: {
    sheet: "Sheet nhập khẩu",
    header: "Dòng tiêu đề",
  },
  button: {
    cancel: "Hủy",
    next: "Tiếp theo",
    back: "Quay lại",
    save: "Lưu",
    submit: "Nhập khẩu",
    changeFile: "Tiếp tục nhập khẩu",
    complete: "Hoàn thành",
    close: "Đóng",
    confirm: "Xác nhận",
  },
  column: {
    unique: "Kiểm tra trùng",
    database: "Cột dữ liệu trên phần mềm",
    file: "Cột dữ liệu trong tệp nhập khẩu",
    map: "Tên cột tự động ghép trong tệp nhập khẩu",
    row: "Dòng",
    result: "Trạng thái",
    status: "Tình trạng",
    error: "Mô tả",
    sheet: "Sheet nhập khẩu",
    customerName: "Tên khách hàng",
    customerCode: "Mã khách hàng",
    totalAmount: "Tổng tiền",
    dueDate: "Hạn thanh toán",
    customerType: "Loại khách hàng",
    taxCode: "Mã số thuế",
    address: "Địa chỉ",
    isOutward: "Kiêm phiếu xuất kho",
    includeInvoice: "Lập kèm hoá đơn",
    productCode: "Mã hàng",
    productName: "Tên hàng",
    productUnitName: "Đơn vị tính",
    productQuantity: "Số lượng",
    productUnitPrice: "Đơn giá",
  },
  result: {
    all: "Tất cả",
    valid: "Hợp lệ",
    invalid: "Không hợp lệ",
    download: "Tải bản ghi không hợp lệ",
    downloadFalse: "Tải tệp chi tiết",
    fileName: "Kết quả kiểm tra",
    step4ResutlTrue: "Nhập khẩu thành công: ",
    step4ResutlFalse: "Nhập khẩu không thành công: ",
    record: "bản ghi",
    downloadError: "Tải chi tiết lỗi",
  },
  progress: {
    title: "Trạng thái nhập khẩu",
    content: "Đang thực hiện nhập khẩu {0}",
  },
  note: {
    label: "Khi gặp tài sản đã có trong hệ thống thì",
    assetTypelabel: "Khi gặp loại tài sản đã có trong hệ thống thì",
    override: "Cập nhật",
    ignore: "Bỏ qua",
    autoinsertasset: "Tự động Thêm mới/ghi tăng tài sản khi gặp tài sản chưa có trong hệ thống",
  },
  isOutward: {
    true: "Có",
    false: "Không",
  },
  includeInvoice: {
    true: "Có",
    false: "Không",
  },
  /**
   * Nội dung lỗi hiển thị
   */
  error: {
    required: "Thiếu thông tin: {0}",
    duplicate: "Trùng với dòng {0} trong file nhập khẩu",
    dictionary: "Cột <{0}>: Dữ liệu không có trong danh sách.",
    isNotManagementUnit: "Cột <Đơn vị quản lý>: Dữ liệu không được tích chọn Là đơn vị quản lý.",
    arisenParentAssetCategory: "Cột <Thuộc nhóm>: Nhóm tài sản đã có phát sinh Loại tài sản.",
    dictionaryField: "{0}",
    overLength: "Cột <{0}>: Dữ liệu vượt quá giới hạn cho phép.",
    formatTypeError: "Cột <{0}>: không đúng định dạng kiểu dữ liệu.",
    confirmMapping:
      "Cột <{0}> trên phần mềm đang không khớp với cột dữ liệu nào trong tệp nhập khẩu. Bạn có muốn tiếp tục nhập khẩu không?",
    confirmInvalidData: "Có {0} bản ghi không hợp lệ. Bạn có muốn tiếp tục không?",
    DoesNotHaveDataValid: "Không có dòng nào hợp lệ. Vui lòng kiểm tra lại.",
    formatError: "Cột <{0}>: không đúng định dạng.",
    /**
     * thông báo khi xảy ra ngoại lệ
     */
    exception: "Có lỗi xảy ra trong quá trình xử lý.",
    /**
     * Một số lỗi chỉ có khi nhập khẩu tài sản
     */
    EMPLOYEE_IS_NOT_ALLOWED_EMPTY:
      "Cột <Nhân viên> không được để trống khi lựa chọn cấp phát cho nhân viên",
    USEDORGANIZATIONUNIT_IS_NOT_ALLOWED_EMPTY:
      "Cột <Phòng ban> không được để trống khi lựa chọn cấp phát cho phòng ban",
    REPRESENTATIVE_IS_NOT_ALLOWED_EMPTY:
      "Cột <Người đại diện> không được để trống khi lựa chọn cấp phát cho phòng ban",
    ALLOCATIONDATE_IS_NOT_ALLOWED_EMPTY:
      "Cột <Ngày cấp phát> không được để trống khi có lựa chọn cấp phát",
    PURCHASEDATE_IS_NOT_ALLOWED_EMPTY:
      "Cột <Ngày mua> không được để trống khi có lựa chọn cấp phát",
    ALLOCATIONDATE_IS_SMALLER_THAN_PURCHASEDATE:
      "Cột <Ngày cấp phát> không được nhỏ hơn cột <Ngày mua>",
    WARRANTYPERIOD_IS_SMALLER_THAN_PURCHASEDATE:
      "Cột <Hạn bảo hành> không được nhỏ hơn cột <Ngày mua>",
    MAINTENANCEBEGIN_IS_SMALLER_THAN_PURCHASEDATE:
      "Cột <Bắt đầu bảo dưỡng từ> không được nhỏ hơn cột <Ngày mua>",
    ASSET_IS_NOT_A_FIXED_ASSET: "Tài sản quản lý theo số lượng không thể là tài sản cố định.",
    QUANTITY_CAN_NOT_BE_ZERO: "Số lượng của tài sản phải lớn hơn 0",
    ASSET_HAS_ARISE_USAGE_HISTORY:
      "Tài sản đã phát sinh nghiệp vụ ngoài nghiệp vụ ghi tăng. Không được phép ghi đè tài sản.",
    ASSET_HAS_ARISE: "Tài sản đã có phát sinh",
    INPUTQUANTITY_IS_INVALID: "Số lượng tài sản chưa sử dụng không đủ",
    DEPRECIATIONDATE_IS_SMALLER_THAN_PURCHASEDATE:
      "Cột <Ngày bắt đầu khấu hao/phân bổ> không được nhỏ hơn cột <Ngày mua>",
    ASSETCATEGORYCODE_HAS_ARISE_DATA:
      "Loại tài sản phải thuộc nhóm tài sản chi tiết (không có nhóm tài sản cấp con). Vui lòng kiểm tra lại.",
    QUANTITY_BYCODE_BIGGER_THAN_1: "Số lượng tài sản quản lý theo mã phải bằng 1.",
    MANAGEMENT_IS_FATHER: "Không được chọn Đơn vị quản lý cha. Vui lòng kiểm tra lại.",
    REPESENTATIVE_ERROR: "Người đại diện không thuộc phòng ban được cấp phát.",
  },
};
